import { useTranslation } from "react-i18next";

/** Shown while a route's code or the session loads. Quiet on purpose: most loads take a few frames. */
export function Pending() {
  const { t } = useTranslation();
  return (
    <div role="status" aria-live="polite" className="grid min-h-dvh place-items-center">
      <span className="sr-only">{t("common.loading")}</span>
      <span
        aria-hidden
        className="size-6 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent"
      />
    </div>
  );
}
